import { Component, AfterViewInit, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import {
  TdLoadingService,
  TdMediaService,
  TdDialogService,
} from '@covalent/core';

import { MdSelect } from '@angular/material';

import { TecnicasTerapeuticasService, MasterService, LoginService, } from '../../../../services/';

import { AltaTecnicaTerapeuticaComponent } from './altatecnicaterapeutica/altatecnicaterapeutica.component';

import { TecnicaTerapeutica } from '../../../../models';

@Component({
  selector: 'qs-tecnicasterapeuticasdetalle',
  styleUrls: ['./tecnicasterapeuticasdetalle.component.scss'],
  templateUrl: './tecnicasterapeuticasdetalle.component.html',
  viewProviders: [TecnicasTerapeuticasService, MasterService],
})

export class TecnicasTerapeuticasDetalleComponent implements AfterViewInit {

  private sub: any;
  public mode: string;
  public title: string;
  public idPaciente: string;
  public idValoracion: string;

  public tecnicaTerapeutica: TecnicaTerapeutica;
  public tecnicasTerapeuticas: any[];

  public nodes: any = [];

  // Propiedades
  public searchTerm: string = '';

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    let id: string = 'idValoracion';
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('tecnicaterapeutica.load');
    this.sub = this._route.params.subscribe((params: any) => {
      this.idValoracion = params[id];
    });
    this._master.obtenerMasterTecnicasTerpeuticas().subscribe((res: any) => {
      this.tecnicasTerapeuticas = res.respuesta.tecnicas;
      this.nodes = this.tecnicasTerapeuticas;
      this._loadingService.resolve('tecnicaterapeutica.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo técnicas terapeuticas.', 'OK', 6000);
      this._loadingService.resolve('tecnicaterapeutica.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  clearSearchInput(input: any, tree: any): void {
    input.value = '';
    tree.collapseAll();
    tree.clearFilter();
    this._changeDetectorRef.detectChanges();
  }

  search(tree: any, key: any): void {
    if (key.length > 2) {
      tree.filterNodes(key, true);
    }
    this._changeDetectorRef.detectChanges();
  }

  selectNode($event: any): void {
    if ($event.node.data.idPadre !== 'System.DBNull') {
      // Abrimos vista detalle de alta
      this.openDetail($event.node.data);
    } else {
      // Expandimos el la rama
      if ($event.node.hasChildren) {
        if ($event.node.isExpanded) {
          $event.node.collapse();
        } else {
          $event.node.toggleExpanded();
        }
        $event.node.toggleActivated();
      }
    }
  }

  /**
   * Abre una vista detalle de la consulta
   * @param tecnica
   */
  openDetail(tecnica: any): void {
    let dialogRef: any = this._dialogService.open(AltaTecnicaTerapeuticaComponent, {
      data: tecnica.row,
      width: '70%',
      role: 'dialog',
      height: '70%',
    });
    dialogRef.componentInstance.tecnica = tecnica;
    dialogRef.componentInstance.titulo = tecnica.name;
    dialogRef.componentInstance.idValoracion = this.idValoracion;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/tecnicasterapeuticasdetalle.component.ts